// extracted by mini-css-extract-plugin
module.exports = {"errorArea":"betslip-validation-error_errorArea__IEHI2","errorText":"betslip-validation-error_errorText__4GLA6"};